export const ENVIOS_BASE = "/envios";

export interface EnviosMenuItem {
  id: string;
  label: string;
  icon: string;
}

export const ENVIOS_MENU: EnviosMenuItem[] = [
  { id: "todos", label: "Todos", icon: "ri-inbox-line" },
  { id: "links-seguimiento", label: "Links de seguimiento", icon: "ri-link-m" },
  { id: "rutas", label: "Rutas", icon: "ri-route-line" },
  { id: "viajes", label: "Viajes", icon: "ri-truck-line" },
  { id: "envios-inteligentes", label: "Envíos inteligentes", icon: "ri-sparkling-2-line" },
];

export const enviosDefaultRoute = `${ENVIOS_BASE}/todos`;
